import React from 'react';

import {
  Divider, useTheme,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import {PoweredByContainer, StyledLink} from './style';

import {ReactComponent as SchedulerLogo} from 'assets/svg/schedulerLogo.svg';
import {FREE_TRIAL_LINK, LEARN_MORE_LINK} from 'Utils/consts';

/**
 * Powered By Component -
 * @return {ReactElement}
 */
export default function PoweredBy() {
  const {t} = useTranslation();
  const theme = useTheme();
  const showPoweredByZoom = useSelector((s) => s.bookAppointments.showPoweredByZoom);
  return (
    <PoweredByContainer
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing="4px"
      divider={<Divider orientation="vertical" variant="middle" />}
    >
      <SchedulerLogo style={{color: theme.palette.text.secondary, width: '101px'}} />
      <StyledLink
        target="_blank"
        href={LEARN_MORE_LINK}
        tabIndex={1}
      >
        {t('common.learnMore')}
      </StyledLink>
      {showPoweredByZoom && <StyledLink
        target="_blank"
        href={FREE_TRIAL_LINK}
        tabIndex={1}
      >
        {t('common.TryItFree')}
      </StyledLink>}
    </PoweredByContainer>
  );
}
